import { handlerClickLogin, canShowLoginButton, handlerClickSignUp } from './studioHeader';
import directives from './module';
import { AuthenticationSvc } from '../services/AuthenticationSvc';

export const canShowUpgradeButton = (state: ng.ui.IStateService) => () =>
    options.user.subscriptionDetails.wave.name === 'WaveFree' &&
    !(state.is('wave-pricing') || state.is('studio-pricing'));

class WaveHeader implements ng.IComponentController {
    handlerClickLogin = handlerClickLogin(this.$state, this.AuthenticationSvc);
    handlerClickSignUp = handlerClickSignUp('WAVE');
    canShowLoginButton = canShowLoginButton(this.$state);
    canShowUpgradeButton = canShowUpgradeButton(this.$state);

    constructor(
        private $state: ng.ui.IStateService,
        public AuthenticationSvc: AuthenticationSvc
    ) {}
}

directives.component('waveHeader', {
    controller: WaveHeader,
    templateUrl: require('wave-header.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/waveHeader.ts